<template>
  <div class="d-flex align-items-center">
    <div
      :style="'background-color:#8cc63f;color:#fff;border-top-left-radius:5px; border-bottom-left-radius:5px;cursor:pointer;font-size:17px;padding: 5.5px 4px;'"
      @click="decreaseNumber()"
    >
      <i class="fa fa-minus"></i>
    </div>
    <input
      :disabled="disableInput"
      class="m-0"
      style="
        border: 1px solid #7ac8ed;
        padding: 4.9px 0;
        text-align: center;
        width: 45px;
      "
      v-model.number="number"
      @input="handleInput"
      type="number"
    />
    <div
      :style="'background-color:#8cc63f;color:#fff;border-top-right-radius:5px;border-bottom-right-radius:5px;cursor:pointer;font-size:17px;padding: 5.5px 4px;'"
      @click="increaseNumber()"
    >
      <i class="fa fa-plus"></i>
    </div>
  </div>
</template>
<script>
export default {
  props: ["value", "disableInput"],
  data() {
    return {
      number: 0,
    };
  },

  created: function () {
    this.number = this.value;
  },

  methods: {
    decreaseNumber() {
      if (this.disableInput) {
        return;
      }
      if (this.number < 0 || typeof this.number == "string") {
        this.number = 0;
      }
      if (this.number != 0) this.$emit("input", (this.number -= 1));
    },
    increaseNumber() {
      if (this.disableInput) {
        return;
      }
      if (this.number < 0 || typeof this.number == "string") {
        this.number = 0;
      }
      if (this.number != 100) this.$emit("input", (this.number += 1));
    },
    handleInput(e) {
      this.$emit("input", this.number);
    },
  },
  watch: {
    value() {
      this.number = this.value;
    },
  },
};
</script>
<style>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/common/components/numberInput.vue